import { render } from "./App.vue?vue&type=template&id=38637bc9"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "@/assets/css/style.css?vue&type=style&index=0&lang=css"
script.render = render

export default script